/* eslint-disable no-useless-escape */
import { Rule } from 'antd/es/form';

import { INVALID_EMAIL, INVALID_EMAILS } from './messages';

// http://emailregex.com/
export const EMAIL_REGEXP =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([\p{L}\-0-9]+\.)+[\p{L}]{2,}))$/u;

export const TEMPLATES_REGEXP =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const EMAIL_PLACEHOLDER_REGEXP = /(^\{\{[A-Z_\s]+\}\}$)/;

export const EMAIL_TEMPLATES_REGEXP = new RegExp(TEMPLATES_REGEXP.source + '|' + EMAIL_PLACEHOLDER_REGEXP.source);

export const ALLOWED_CHAR_EMAIL = /^[\p{L}0-9@._+-]$/u;
export const ALLOWED_PASTE_EMAIL = /^[\p{L}0-9@._+-]+$/u;

export const ALLOWED_CHAR_TEMPLATES_EMAIL = /^[a-zA-Z0-9@._+-]$/;
export const ALLOWED_PASTE_TEMPLATES_EMAIL = /^[a-zA-Z0-9@._+-]+$/;

export const emailValidation = (value: string | null | undefined) => {
  return typeof value === 'string' && value.length <= 320 && !!value.match(EMAIL_REGEXP);
};

export const emailValidator: Rule = {
  message: INVALID_EMAIL,
  validator: (rule, value: string | null | undefined) => {
    if (!value) {
      return Promise.resolve();
    }

    return emailValidation(value) ? Promise.resolve() : Promise.reject(new Error(INVALID_EMAILS));
  },
};
